<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style lang="scss">
* {
    box-sizing: border-box;
    font-family: Source Han Sans CN;
}
// body {
//     @font-face{
//         font-family: 'Bebas';
//         src: url('../static/font/Bebas-1.ttf');
//     }
// }
html,
body,
#app {
    height: 100%;
    //overflow-x: hidden;
    /deep/ .el-table {
        font-size: 14px;
        .has-gutter {
            background-color: #f6efed;
        }
    }
}

@media screen and (min-width: 768px) {
    * {
        font-size: 14px;
    }
    .table-normal {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 50px;
        > img {
            width: 374px;
            height: 280px;
        }
        > span {
            font-size: 16px;
            color: #999;
        }
    }
}

@media screen and (max-width: 768px) {
    .table-normal {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 50px;
        > img {
            width: 3.74rem;
            height: 2.8rem;
        }
        > span {
            font-size: 0.24rem;
            color: #999;
        }
    }
}

.table-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .table-box {
        flex: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue